/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fw_Node_MangaInputs */

const en_fw_node_manga = /** @type {(inputs: Fw_Node_MangaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Manga`)
};

const zh_fw_node_manga = /** @type {(inputs: Fw_Node_MangaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`原作`)
};

/**
* | output |
* | --- |
* | "Manga" |
*
* @param {Fw_Node_MangaInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const fw_node_manga = /** @type {((inputs?: Fw_Node_MangaInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fw_Node_MangaInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_fw_node_manga(inputs)
	return zh_fw_node_manga(inputs)
});
export { fw_node_manga as "fw.node.manga" }